import { ClientSideRowModelModule } from "@ag-grid-community/client-side-row-model";
import {
  GridApi,
  GridOptions,
  ModuleRegistry,
  RowNode,
  ShouldRowBeSkippedParams,
} from "@ag-grid-community/core";

import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";

import { PriceyardService } from "src/app/modules/priceyard/services/priceyard.service";
import { HeaderService } from "src/app/components/header/header.service";

import { filter, takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";

import Swal from "sweetalert2";

import { GridActionsService } from "../../grid-actions.service";
import { AuthService } from "../../../services/auth.service";
import { InventoryService } from "../../../services/inventory.service";
import { ColumnSelectorHeaderRendererComponent } from "./../../../ag-grid-components/column-selector-header-renderer/column-selector-header-renderer.component";
import { StatusBarRendererComponent } from "../../../ag-grid-components/status-bar-renderer/status-bar-renderer.component";
import {SnackbarComponent} from '../../../components/snackbar/snackbar.component';
ModuleRegistry.registerModules([ClientSideRowModelModule]);

@Component({
  selector: "app-bulk-import-review",
  templateUrl: "./bulk-import-review.component.html",
  styleUrls: ["./bulk-import-review.component.scss"],
})
export class BulkImportReviewComponent implements OnInit, OnDestroy {
  gridApi: GridApi;
  gridOptions: GridOptions;
  columnDefs: any[] = [];
  rowData;
  skuColumnIndex: number;
  invalidSkus: string[] = [];
  validated: boolean;
  validatedData: any[];
  private destroy$ = new Subject<void>();
  @Output() exportData: EventEmitter<any[]> = new EventEmitter();
  @Output() close: EventEmitter<boolean> = new EventEmitter();
  @Output() actionChanged: EventEmitter<any> = new EventEmitter();
  account: string;
  actions;
  showValidateLoader = false;
  showSubmitLoader = false;
  showRemoveLoader = false;
  modelList = [];
  headerRow = [];
  @Input() event;
  isDisable: boolean = false;
  _data: any;
  get data(): any {
    return this._data;
  }
  @Input() set data(value: any) {
    this._data = value;
    this.constructGrid(this._data?.tableData);
    this.loadModals();
  }
  errorRowCount:number=0;
  isInvalidHeaderName: boolean= false;

  constructor(
    public gridActionsService: GridActionsService,
    private priceyardService: PriceyardService,
    private headerService: HeaderService,
    protected snackBar: MatSnackBar,
    private inventoryService: InventoryService,
    private authService: AuthService
  ) {
    this.gridActionsService.changedEvent$
      .pipe(takeUntil(this.destroy$))
      .subscribe((res) => {
        this.event = res;
        if (this.event) {
          if (this.event == "validate") this.validate(false, true);
          else if (this.event == "Submit") this.submit(true);
        }
      });
    this.gridActionsService.changedHeader$.pipe(takeUntil(this.destroy$)).subscribe((res) => {
      if (res) {
        this.isDisable = false;
        this.disableAction();
      } else {
        this.isDisable = true;
        this.disableAction();
      }
    });
  }

  ngOnInit(): void {
    this.headerService.accountsSelected.pipe(takeUntil(this.destroy$)).subscribe((e) => {
      this.account = e[0];
    });
    this.actions = [
      { text: "Cancel", buttonStyle: "underline" },
      {
        text: "validate",
        isDisabled: this.isDisable,
        spin: this.showValidateLoader,
      },
      {
        text: "Submit",
        isDisabled: this.isDisable,
        spin: this.showSubmitLoader,
      },
    ];
    this.actionChanged.emit(this.actions);

    this.headerService.remoteActionBroadcaster
    .pipe(filter((e) => e.action === "ChangePriceFactorP"))
    .subscribe((e) => {
      if (e.response.responseType.toLowerCase() === "done" ){
            this.snackBar.openFromComponent(SnackbarComponent,
                {
                  duration: 3000,
                  horizontalPosition: 'center',
                  data: {
                    title: 'File processing completed',
                    action: 'Dismiss',
                    type: 'info',
                  },
                }
            );
          this.showSubmitLoader = false;
          this.close.emit(true);
          this.gridActionsService.refreshData();
          this.actions[2].spin = this.showSubmitLoader;
          this.actionChanged.emit(this.actions);
          Swal.fire({
            title: "",
            text: "Your data was updated successfully! Your changes will reflect in the system within a few minutes",
            icon: "success",
            confirmButtonText: "OK",
            width: 350,
            position: "center",
          });
      } else if (e.response.responseType.toLowerCase() === "error") {
        this.showSubmitLoader = false;
        this.actions[2].spin = this.showSubmitLoader;
        this.snackBar.openFromComponent(SnackbarComponent,
          {
            duration: 3000,
            horizontalPosition: 'center',
            data: {
              title: 'Operation unsuccessfull.',
              action: 'Dismiss',
              type: 'error',
            },
          }
        );
        this.close.emit(true);
      }
    });
  }

  gridReady(e) {
    this.gridApi = e.api;
    if (this.columnDefs.length <= 10) {
      this.gridApi.sizeColumnsToFit();
    }
  }

  disableAction(): void {
    if (this.actions) {
      this.actions[1].isDisabled = this.isDisable;
      this.actions[2].isDisabled = this.isDisable;
      this.actionChanged.emit(this.actions);
    }
  }

  constructGrid(data) {
    this.columnDefs = this.columnDefsConstructor(data[0]);
    this.headerRow = data.shift();
    this.rowData = data;
    const skuIndex = this.headerRow.findIndex((item: any) => {
      return item.toLowerCase() === "sku";
    });
    if (skuIndex === -1) this.isDisable = true;
    else this.isDisable = false;
    this.constructColumns();
    this.gridOptions = {
      // colWidth: 100,
      headerHeight: 38,
      rowHeight: 33,
      rowData: this.rowData,
      columnDefs: this.columnDefs,
      onGridReady: (e) => this.gridReady(e),
      defaultColDef: {
        sortable:false,
      },
      components: {
        columnSelectorHeaderRendererComponent:
          ColumnSelectorHeaderRendererComponent,
        statusBarRendererComponent: StatusBarRendererComponent,
      },
      statusBar: {
        statusPanels: [
          {
            statusPanel: "statusBarRendererComponent",
            align: "left",
            statusPanelParams: { model: false },
          },
        ],
      },
      getRowStyle: (params) => {
        if (params.node.data.error || this.isInvalidHeaderName) {
          return { background: "var(--color-accent-light)" };
        }
        if (params.rowIndex === 0 && params.node.rowPinned === "top") {
          return { background: "var(--color-gray-1)" };
        }
      },
    };
  }

  constructColumns() {
    const columnHeader = this.headerRow;
    Object.values(columnHeader).forEach((key: string, index: number) => {
      const selectedColumnIndex =
        this.gridActionsService.selectedColumnMap.findIndex((item: any) => {
          return item.name.toLowerCase() === key.toLowerCase();
        });
      if (selectedColumnIndex !== -1) {
        this.gridActionsService.selectedColumnMap[
          selectedColumnIndex
        ].columnIndex = index;
      }
    });
   if(!this.data?.isPriceSettings) this.columnValidators(columnHeader);
  }

  loadModals(): void {
    this.priceyardService.GetPriceModel().pipe(takeUntil(this.destroy$)).subscribe((res) => {
      this.modelList = res.map((model) => model.name);
    });
  }

  // ValidatBulkSkus

  columnDefsConstructor(data) {
  if(!this.data?.isPriceSettings){
    this.gridActionsService.selectedColumnMap = [
      { name: "Sku", columnIndex: null },
      { name: "Min Price", columnIndex: null },
      { name: "PricingOn", columnIndex: null },
      { name: "Sync Inventory", columnIndex: null },
      { name: "Max Sync Qty", columnIndex: null },
      { name: "Length", columnIndex: null },
      { name: "Width", columnIndex: null },
      { name: "Weight", columnIndex: null },
      { name: "Height", columnIndex: null },
      { name: "Prep Cost", columnIndex: null },
      { name: "Ship Cost", columnIndex: null },
      { name: "Map Price", columnIndex: null },
    ];
    this.authService.userInfo$
      .pipe(takeUntil(this.destroy$))
      .subscribe((res) => {
        if (res.isPriceYard !== null)
          this.gridActionsService.selectedColumnMap = [
            ...this.gridActionsService.selectedColumnMap,
            ...[
              { name: "Cost", columnIndex: null },
              { name: "Max Price", columnIndex: null },
              { name: "Markup", columnIndex: null },
              { name: "Min Markup", columnIndex: null },
              { name: "Default Price", columnIndex: null },
              { name: "Prep Cost", columnIndex: null },
              { name: "Repricing model", columnIndex: null },
              { name: "Map Price", columnIndex: null },
              { name: "MAP enforce", columnIndex: null },
              { name: "Ship Cost", columnIndex: null },
            ],
          ];
        if (res.isShipyard !== null || res.isPlanYard !== null)
          this.gridActionsService.selectedColumnMap = [
            ...this.gridActionsService.selectedColumnMap,
            ...[
              { name: "Case Qty", columnIndex: null },
              { name: "Upc", columnIndex: null },
              { name: "Note", columnIndex: null },
              { name: "Expirable", columnIndex: null },
              { name: "IsActive", columnIndex: null },
            ],
          ];
      });
  }else{
    this.gridActionsService.selectedColumnMap = [
      { name: "Sku", columnIndex: null },
      { name: "Min Price", columnIndex: null },
      { name: "Repricing model", columnIndex: null },
      { name: "Repricing(On/Off)", columnIndex: null },
      { name: "Min Price(Auto/Manual)", columnIndex: null },
      { name: "Prep Cost", columnIndex: null },
      { name: "Ship Cost", columnIndex: null },
      { name: "Cost", columnIndex: null },
      { name: "Max Price", columnIndex: null },
      { name: "Max Price(Auto/Manual)", columnIndex: null },
      { name: "MarkUp", columnIndex: null },
      { name: "Min MarkUp", columnIndex: null },
      { name: "Default Price", columnIndex: null },
      { name: "Map Price", columnIndex: null },
      { name: "Map Price(On/Off)", columnIndex: null }
    ];
  }

    return Object.keys(data).map((column) => {
      return {
        field: column,
        headerComponent: "columnSelectorHeaderRendererComponent",
      };
    });
  }

  validate(isSubmit, validate) {
    this.showValidateLoader = validate;
    this.actions[1].spin = this.showValidateLoader;
    this.actionChanged.emit(this.actions);
    this.skuColumnIndex = this.gridActionsService.selectedColumnMap.findIndex(
      (e) => e.name === "Sku"
    );
    this.validatedData = [];
    this.gridApi.forEachNode((node) => {
      this.validatedData.push(node.data);
    });

    this.validatedData = this.validatedData.filter(
      (item) => item.filter((e) => e).length > 1
    );
    this.validateIfSkuExists(this.validatedData, isSubmit);
  }

  rowValidation(isSubmit): void {
    const selectedColumnMap = this.gridActionsService.selectedColumnMap.filter(
      (e) => e.columnIndex !== null
    );
    const sku = selectedColumnMap.find((res) => res.name === "Sku");
    const minPrice = selectedColumnMap.find((res) => res.name === "Min Price");
    const maxPrice = selectedColumnMap.find((res) => res.name === "Max Price");

    this.gridApi.forEachNode((node) => {
      const row = node.data;
      let validRow = true;
      selectedColumnMap.forEach((column) => {
        if (
          row[column.columnIndex].toString().toLowerCase() !== "delete" &&
          ((validRow &&
            !["Sku","Min Price", "Repricing model", "MAP enforce", "Note","PricingOn", "Expirable","Sync Inventory",
            "Max Sync Qty","Upc","IsActive","Length","Width","Weight","Height","Case Qty","Cost","Max Price","Markup","Min Markup","Default Price",
            "Prep Cost","Map Price","Ship Cost",].includes(column.name) &&
            this.isValidFactorValue(row, column, minPrice, maxPrice)) ||
            this.isValidRepricingModel(column.name, row[column.columnIndex]) ||
            this.isValidExpirable(column.name, row[column.columnIndex]) ||
            this.isValidIsActive(column.name, row[column.columnIndex]) ||
            this.isValidMapEnforce(column.name, row[column.columnIndex]) ||
            this.isValidPricingOn(column.name, row[column.columnIndex]) || 
            this.isValidSyncInventory(column.name, row[column.columnIndex]))
        ) {
          validRow = false;
        }
        if (!validRow && !this.invalidSkus.includes(row[sku.columnIndex])) {
          this.invalidSkus.push(row[sku.columnIndex]);
          node.setData({ ...node.data, error: "not exsist" });
        }
      });
    });

    this.showValidateLoader = false;
    this.showSubmitLoader = false;
    this.actions[1].spin = this.showValidateLoader;
    this.actions[2].spin = this.showSubmitLoader;
    this.disableAction();
    this.actionChanged.emit(this.actions);
    if (!this.invalidSkus.length && isSubmit) {
      this.submit(false);
    }
  }

  rowValidationForPricingSttings(isSubmit): void {
    const selectedColumnMap = this.gridActionsService.selectedColumnMap.filter(
      (e) => e.columnIndex !== null
    );
    const sku = selectedColumnMap.find((res) => res.name === "Sku");
    const minPrice = selectedColumnMap.find((res) => res.name === "Min Price");
    const maxPrice = selectedColumnMap.find((res) => res.name === "Max Price");
    this.gridApi.forEachNode((node) => {
      const row = node.data;
      let validRow = true;
      selectedColumnMap.forEach((column) => {
        if (((validRow &&
            !["Sku","Min Price","Repricing model", "Repricing(On/Off)","Min Price(Auto/Manual)" , "Prep Cost", "Ship Cost","Cost","Max Price","Max Price(Auto/Manual)","MarkUp","Min MarkUp","Default Price","Map Price", "Map Price(On/Off)"].includes(column.name) &&
            this.isValidFactorValue(row, column, minPrice, maxPrice)) ||
            this.isValidRepricingModel(column.name, row[column.columnIndex]) ||
            this.isValidRepricingModelActive(column.name, row[column.columnIndex]) ||
            this.isValidMinAndMaxPrice(column.name, row[column.columnIndex]))
        ) {
          validRow = false;
        }
        if (!validRow && !this.invalidSkus.includes(row[sku.columnIndex])) {
          this.invalidSkus.push(row[sku.columnIndex]);
          node.setData({ ...node.data, error: "not exsist" });
        }
      });
    });

    this.showValidateLoader = false;
    this.showSubmitLoader = false;
    this.actions[1].spin = this.showValidateLoader;
    this.actions[2].spin = this.showSubmitLoader;
    this.disableAction();
    this.actionChanged.emit(this.actions);
    if (!this.invalidSkus.length && isSubmit) {
      this.submit(false);
    }
  }

  isValidMinAndMaxPrice(columnName, value): boolean {
    return (
      (columnName === "Min Price(Auto/Manual)" || columnName === "Max Price(Auto/Manual)") &&
      !(["auto", "manual"].includes(value.toLowerCase()) || !value)
    );
  }

  isValidRepricingModelActive(columnName, value): boolean {
    return (
      (columnName === "Repricing(On/Off)" || columnName === "Map Price(On/Off)") &&
      !(["on", "off" , "true" , "false"].includes(value.toLowerCase()) || !value)
    );
  }

  isValidFactorValue(row, column, minPrice, maxPrice): boolean {
    return (
      isNaN(row[column.columnIndex]) ||
      (minPrice &&
        maxPrice &&
        Number(row[minPrice.columnIndex]) > Number(row[maxPrice.columnIndex]))
    );
  }

  isValidRepricingModel(columnName, modelName): boolean {
    let isValidRModel = columnName === "Repricing model" && !(this.modelList.includes(modelName) || !modelName);
    if(isValidRModel && columnName === "Repricing model"){
      this.snackBar.openFromComponent(SnackbarComponent,
        {
          duration: 3000,
          horizontalPosition: 'center',
          data: {
            title: 'Please enterd a valid repricing model.',
            action: 'Dismiss',
            type: 'error',
          },
        }
      );
    }
    return isValidRModel;  
  }

  isValidMapEnforce(columnName, value): boolean {
    return (
      columnName === "MAP enforce" &&
      !(["true", "false", "on", "off"].includes(value.toLowerCase()) || !value)
    );
  }

  isValidPricingOn(columnName, value): boolean {
    return (
      columnName === "PricingOn" &&
      !(["yes", "no","on", "off","true","false"].includes(value.toLowerCase()) || !value)
    )
  }


  isValidExpirable(columnName, value): boolean {
    return (
      columnName === "Expirable" &&
      !(["yes", "no", "true", "false", "on", "off"].includes(value.toLowerCase()) || !value)
    );
  }

  
  isValidIsActive(columnName, value): boolean {
    return (
      columnName === "IsActive" &&
      !(["yes", "no", "true", "false", "on", "off"].includes(value.toLowerCase()) || !value)
    );
  }

  isValidSyncInventory(columnName, value): boolean {
    return (
      columnName === "Sync Inventory" &&
      !(["yes", "no", "true", "false", "on", "off"].includes(value.toLowerCase()) || !value)
    );
  }

  validateIfSkuExists(data, isSubmit) {
    this.errorRowCount=0
    const payload = {
      account: this.account,
      skus: this.constructValidatePayload(data),
    };
    const duplicatesSku = payload.skus.filter(
      (item, index) => payload.skus.indexOf(item) !== index
    );
    this.invalidSkus = [...this.invalidSkus, ...duplicatesSku];
    this.inventoryService.ValidateBulkSkus(payload).pipe(takeUntil(this.destroy$)).subscribe({
      next: (res:any) => {
        this.validated = true;
        if (res.invalidSkus.length) {
          this.invalidSkus = [...this.invalidSkus, ...res.invalidSkus];
        }
        this.invalidSkus.forEach((item) => {
          this.gridApi.forEachNode((node: RowNode) => {
            if (node.data[this.skuColumnIndex].toLowerCase() === item.toLocaleLowerCase()) {
              node.setData({ ...node.data, error: "not exist" });
            }
          });
        });
       
        this.gridApi.forEachNode((node: RowNode) => {
          if(node.data.error)
          this.errorRowCount +=1;
        })
       
        this.data?.isPriceSettings ? this.rowValidationForPricingSttings(isSubmit) : this.rowValidation(isSubmit);
        this.invalidSkus && this.invalidSkus?.length != 0
          ? (this.isDisable = true)
          : (this.isDisable = false);
        this.disableAction();
      },
     error: (err) => {
      this.showValidateLoader = false;
      this.actions[1].spin = this.showValidateLoader;
      this.showSubmitLoader = false;
      this.actions[2].spin = this.showSubmitLoader;
     }
   });
  }

  constructValidatePayload(data) {
    return data
      .map((item) => {
        return item[this.skuColumnIndex];
      })
      .filter((e) => e);
  }

  removeInvalideSkus(validate) {
    this.showRemoveLoader = validate;
    setTimeout(() => this.removeInvalideSkuLoader(), 3000);
  }

  removeInvalideSkuLoader() {
    this.dowloadInvalidSkus();
    this.invalidSkus.forEach((item) => {
      this.gridApi.forEachNode((node: RowNode) => {
        if (node.data[this.skuColumnIndex].toLowerCase() === item.toLocaleLowerCase()) {
          this.gridApi.applyTransaction({ remove: [node.data] });
        }
      });
    });
    this.showRemoveLoader = false;
    this.invalidSkus = [];
    this.actions[1].isDisabled = false;
    this.actions[2].isDisabled = false;
  }

  dowloadInvalidSkus() {
    this.gridApi.exportDataAsCsv({
      shouldRowBeSkipped: (params: ShouldRowBeSkippedParams): boolean => {
        return params.node.data?.error ? false : true;
      },
      skipColumnHeaders : true,
    });
  }

  submit(checkValidation: boolean) {
    this.showSubmitLoader = true;
    this.actions[2].spin = this.showSubmitLoader;
    this.actionChanged.emit(this.actions);
    if (checkValidation) {
      this.validate(true, false);
    }
    if (!checkValidation && this.validated && !this.invalidSkus.length) {
      const skusList = this.data?.isPriceSettings ? this.constructBulkPriceSettingPayload() :this.constructBulkPayload();
      this.priceyardService.changePriceFactorP(skusList).pipe(takeUntil(this.destroy$)).subscribe({
        next: (res) => {
        },
       error: (err) => {
        this.showSubmitLoader = false;
        this.actions[2].spin = this.showSubmitLoader;
        this.snackBar.openFromComponent(SnackbarComponent,
          {
            duration: 3000,
            horizontalPosition: 'center',
            data: {
              title: err.error.title,
              action: 'Dismiss',
              type: 'error',
            },
          }
        );
       }
     });
    }
  }

  cancel() {
    this.close.emit();
  }

  constructBulkPayload() {
    const skusList = [];
    const mapEnforce = this.gridActionsService.selectedColumnMap.find(
      (res) => res.name === "MAP enforce"
    );
    const mapPrice = this.gridActionsService.selectedColumnMap.find(
      (res) => res.name === "Map Price"
    );
    const RepricingModel = this.gridActionsService.selectedColumnMap.find(
      (res) => res.name === "Repricing model"
    );
    const caseQty = this.gridActionsService.selectedColumnMap.find(
      (res) => res.name === "Case Qty"
    );
    const Upc = this.gridActionsService.selectedColumnMap.find(
      (res) => res.name === "Upc"
    );
    const Note = this.gridActionsService.selectedColumnMap.find(
      (res) => res.name === "Note"
    );
    const PricingOn = this.gridActionsService.selectedColumnMap.find(
        (res) => res.name === "PricingOn"
    );
    const Expirable = this.gridActionsService.selectedColumnMap.find(
      (res) => res.name === "Expirable"
    );
    const IsActive = this.gridActionsService.selectedColumnMap.find(
      (res) => res.name === "IsActive"
    );
    const SyncInventory = this.gridActionsService.selectedColumnMap.find(
      (res) => res.name === "Sync Inventory"
    );
    const Length = this.gridActionsService.selectedColumnMap.find(
      (res) => res.name === "Length"
    );
    const Width = this.gridActionsService.selectedColumnMap.find(
      (res) => res.name === "Width"
    );
    const Weight = this.gridActionsService.selectedColumnMap.find(
      (res) => res.name === "Weight"
    );
    const Height = this.gridActionsService.selectedColumnMap.find(
      (res) => res.name === "Height"
    );
    const MaxSyncQty = this.gridActionsService.selectedColumnMap.find(
      (res) => res.name === "Max Sync Qty"
    );

    this.validatedData.forEach((data) => {
      const elementList = [];
      this.gridActionsService.selectedColumnMap
        .filter(
          (item: any) =>
            item.columnIndex &&
            item.name !== "Sku" &&
            item.name !== "Case Qty" &&
            item.name !== "Upc" &&
            item.name !== "Note" &&
            item.name !== "PricingOn" &&
            item.name !== "Expirable" &&
            item.name !== "Repricing model" && 
            item.name !== "Sync Inventory" && 
            item.name !== "Max Sync Qty" && 
            item.name !== "IsActive" && 
            item.name !== "Length" && 
            item.name !== "Width" && 
            item.name !== "Weight" && 
            item.name !== "Height"
          )
        .forEach((column: any) => {
          if (column.name === "MAP enforce" && mapPrice.columnIndex === null) {
            column = { columnIndex: "auto", name: "Map Price" };
          }
          if (column.name !== "MAP enforce") {
            if (data[column.columnIndex] != "") {
              const item = {
                value:
                  data[column.columnIndex] !== "auto" &&
                  data[column.columnIndex].toLowerCase() !== "delete" &&
                  column.columnIndex !== "auto"
                    ? column.name === "Markup"
                      ? +data[column.columnIndex] / 100
                      : +data[column.columnIndex]
                    : 0,
                factor: column.name,
              };
              elementList.push(item);
            } else {
              elementList.push({
                setAuto: true,
                factor: column.name,
              });
            }
          }
        });
      if (data[this.skuColumnIndex]) {
        const sku = {
          sku: data[this.skuColumnIndex],
          account: this.account,
          fulfillmentType: "Fba",
          pricingOn: data[PricingOn.columnIndex] === 'on',
          changingFactors: elementList,
          modelName: data[RepricingModel?.columnIndex],
        };
        sku["otherChanges"] = [];
        if (
          caseQty &&
          caseQty.columnIndex !== null &&
          data[caseQty.columnIndex]
        ) {
          sku["otherChanges"].push(
            {
              intValue: +data[caseQty.columnIndex],
              name: "BoxQty",
            },
          );
        }

        if (Upc && Upc.columnIndex !== null && data[Upc.columnIndex]) {
          sku["otherChanges"].push(
            {
              stringValue: data[Upc.columnIndex],
              name: "Upc",
            },
          );
        }

        if (Note && Note.columnIndex !== null && data[Note.columnIndex]) {
          sku["otherChanges"].push(
            {
              stringValue: data[Note.columnIndex],
              name: "Note",
            },
          );
        }

        if (Expirable && Expirable.columnIndex !== null && data[Expirable.columnIndex]) {
          sku["otherChanges"].push(
            {
              boolValue: ['on', 'yes', 'true'].includes(data[Expirable.columnIndex].toLowerCase()),
              name: "Expirable",
            },
          );
        }

        if (IsActive && IsActive.columnIndex !== null && data[IsActive.columnIndex]) {
          sku["otherChanges"].push(
            {
              boolValue: ['on', 'yes', 'true'].includes(data[IsActive.columnIndex].toLowerCase()),
              name: "IsActive",
            },
          );
        }

        if (SyncInventory && SyncInventory.columnIndex !== null && data[SyncInventory.columnIndex]) {
          sku["otherChanges"].push(
            {
              boolValue: ['on', 'yes', 'true'].includes(data[SyncInventory.columnIndex].toLowerCase()),
              name: "SyncStockEnabled",
            },
          );
        }

        if (MaxSyncQty && MaxSyncQty.columnIndex !== null && data[MaxSyncQty.columnIndex]) {
          sku["otherChanges"].push(
            {
              intValue: +data[MaxSyncQty.columnIndex],
              name: "MaxSyncQty",
            },
          );
        }
        if (Height && Height.columnIndex !== null && data[Height.columnIndex]) {
          sku["otherChanges"].push(
            {
              doubleValue: data[Height.columnIndex],
              name: "CaseHeight",
            },
          );
        }
        if (Width && Width.columnIndex !== null && data[Width.columnIndex]) {
          sku["otherChanges"].push(
            {
              doubleValue: data[Width.columnIndex],
              name: "CaseWidth",
            },
          );
        }
        if (Weight && Weight.columnIndex !== null && data[Weight.columnIndex]) {
          sku["otherChanges"].push(
            {
              doubleValue: data[Weight.columnIndex],
              name: "CaseWeight",
            },
          );
        }
        if (Length && Length.columnIndex !== null && data[Length.columnIndex]) {
          sku["otherChanges"].push(
            {
              doubleValue: data[Length.columnIndex],
              name: "CaseLength",
            },
          );
        }

        skusList.push(sku);
      }
    });

    return skusList;
  }

  constructBulkPriceSettingPayload() {
    const skusList = [];
    const repricingModel = this.gridActionsService.selectedColumnMap.find(
      (res) => res.name === "Repricing model"
    );
    const PricingOn = this.gridActionsService.selectedColumnMap.find(
        (res) => res.name === "Repricing(On/Off)"
    );
    this.validatedData.forEach((data) => {
      const elementList = [];
      this.gridActionsService.selectedColumnMap
      .filter(
        (item: any) =>
          item.columnIndex &&
          item.name !== "Repricing(On/Off)" &&
          item.name !== "Max Price(Auto/Manual)" &&
          item.name !== "Min Price(Auto/Manual)" &&
          item.name !== "Map Price(On/Off)" &&
          item.name !== "Sku" &&
          item.name !== "Repricing model"
        ).forEach((column: any) => {
          if (column.name === "Min Price" || column.name === "Repricing model" ||column.name === "Max Price" ||column.name === "Map Price" ) {
            column.type = "auto";
          }
          switch (column.name) {
            case "Min Price":
              column.columnTypeIndex = this.gridActionsService.selectedColumnMap.findIndex((res) => res.name === 'Min Price(Auto/Manual)')
            break;
            case "Repricing model":
              column.columnTypeIndex = this.gridActionsService.selectedColumnMap.findIndex((res) => res.name === 'Repricing(On/Off)')
            break;
            case "Max Price":
              column.columnTypeIndex = this.gridActionsService.selectedColumnMap.findIndex((res) => res.name === 'Max Price(Auto/Manual)')
            break;
            case "Map Price":
              column.columnTypeIndex = this.gridActionsService.selectedColumnMap.findIndex((res) => res.name === 'Map Price(On/Off)')
            break;
          }
          
            if (data[column.columnIndex] != "") {
              let item : any= {
                value:
                  data[column.columnIndex] !== "auto" &&
                  data[column.columnIndex]?.toLowerCase() !== "delete" &&
                  column.columnIndex !== "auto"
                    ? column.name === "Markup"
                      ? +data[column.columnIndex] / 100
                      : +data[column.columnIndex]
                    : 0,
                factor: column.name,
              };
              if(column?.type === 'auto'){
                if(data[column.columnTypeIndex].toLowerCase() === 'true' || data[column.columnTypeIndex].toLowerCase() === 'auto' || data[column.columnTypeIndex].toLowerCase() === 'on'){
                  item.setAuto =  true;
                } else if(data[column.columnTypeIndex].toLowerCase() === 'false' || data[column.columnTypeIndex].toLowerCase() === 'manual' || data[column.columnTypeIndex].toLowerCase() === 'off'){
                  item.setAuto =  false;
                }
              } 
              elementList.push(item);
            }          
        });
      if (data[this.skuColumnIndex]) {
        const sku = {
          sku: data[this.skuColumnIndex],
          account: this.account,
          fulfillmentType: "Fba",
          pricingOn: data[PricingOn.columnIndex].toLowerCase() === 'on',
          changingFactors: elementList,
          modelName: data[repricingModel?.columnIndex],
        };
        skusList.push(sku);
      }
    });

    return skusList;
  }

  getMapEnforce(value): boolean {
    if (value != "") {
      if (["off", "false"].includes(value.toLowerCase())) {
        return false;
      } else if (["on", "true"].includes(value.toLowerCase())) {
        return true;
      }
    } else return false;
  }

  columnValidators(columnHeader) { 
    columnHeader.forEach((res)=>{
     if(!res.match(/^[-\w\s]+$/)) {
       this.isInvalidHeaderName = true;
     }
   })
   this.isDisable = this.isInvalidHeaderName ? true : false
   this.disableAction();
 }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }
}